import { render, staticRenderFns } from "./GAMapping.vue?vue&type=template&id=cbdba694&lang=pug"
import script from "./GAMapping.vue?vue&type=script&lang=js"
export * from "./GAMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports